import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AnimatePresence } from 'framer-motion';
import Layout from './components/Layout';
import Home from './pages/Home';
import Kontakt from './pages/Kontakt';
import FoerEfter from './pages/FoerEfter';
import Privatliv from './pages/Privatliv';
import ServicePage from './pages/ServicePage';
import PageTransition from './components/PageTransition';

function App() {
  const location = useLocation();

  return (
    <HelmetProvider>
      <Layout>
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<PageTransition><Home /></PageTransition>} />
            <Route path="/foer-efter" element={<PageTransition><FoerEfter /></PageTransition>} />
            <Route path="/kontakt" element={<PageTransition><Kontakt /></PageTransition>} />
            <Route path="/privatliv" element={<PageTransition><Privatliv /></PageTransition>} />
            
            {/* Dynamic Pages from CMS */}
            <Route path="/:slug" element={<PageTransition><ServicePage /></PageTransition>} />
            
            {/* Fallback */}
            <Route path="*" element={<PageTransition><Home /></PageTransition>} />
          </Routes>
        </AnimatePresence>
      </Layout>
    </HelmetProvider>
  );
}

export default App;
